var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex-content"},[_c('div',{style:({
        width: '55%',
        height: '420px'
      }),attrs:{"id":"chartGJC"}}),_c('PortalCommonTable',{staticClass:"GJCTable",attrs:{"no-pagination":"","align-text":"left","serial-text":"排名","table-data":_vm.GJCTableData,"column-data":_vm.GJCColumnData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }